import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { TableContainerRoot } from './TableContainerStyles';
import { conditionalClassNames } from '../../../../UtilityComponents/Util';

/**
 *
 * @param {Object} classes - {
 * root - Class applied to all TableHead
 * }
 */

const TableContainer = ({ classes = {}, forwardedRef, ...other }) => {
	const { root } = classes;
	const className = conditionalClassNames({
		[root]: root
	});
	return (
		<TableContainerRoot
			className={className}
			ref={forwardedRef}
			{...other}
		/>
	);
};

TableContainer.propTypes = {
	classes: PropTypes.object
};

export default forwardRef((props, ref) => <TableContainer {...props} forwardedRef={ref} />);
